import { sortRoomsByNumber } from './bookingUtils';
import { groupRooms } from './roomUtils';

/**
 * Build walk-in room sections for Full / Floor / Room Type grouping.
 * Keeps per-room-type availability metadata for selection limits.
 */
export function buildWalkInDisplayGroups(filteredRoomsData, groupView = 'room_type') {
  if (!filteredRoomsData?.length) return [];

  if (groupView === 'room_type') {
    return filteredRoomsData.map((group) => ({
      key: String(group.room_type.id),
      label: group.room_type.name,
      roomTypeGroup: group,
      rooms: sortRoomsByNumber(group.rooms || []),
      total_rooms: group.total_rooms ?? 0,
      booked_rooms: group.booked_rooms ?? 0,
      blocked_rooms: group.blocked_rooms ?? 0,
      max_available_rooms: group.max_available_rooms ?? 0,
      isDisabled: group.isDisabled === true,
    }));
  }

  const flatRooms = [];
  filteredRoomsData.forEach((roomTypeGroup) => {
    (roomTypeGroup.rooms || []).forEach((room) => {
      flatRooms.push({
        ...room,
        room_type_id: roomTypeGroup.room_type.id,
        floor_number: room.floor ?? room.floor_number ?? null,
        floor_id: room.floor_id ?? room.floor ?? 'none',
        floor_name:
          room.floor_name ??
          (room.floor != null && room.floor !== '' ? `Floor ${room.floor}` : 'No Floor'),
      });
    });
  });

  const roomTypes = filteredRoomsData.map((group) => group.room_type);
  const grouped = groupRooms(flatRooms, roomTypes, groupView);

  return Object.values(grouped)
    .filter((group) => (group.rooms || []).length > 0)
    .map((group) => {
      const rooms = sortRoomsByNumber(group.rooms || []);
      const available = rooms.filter((room) => room.is_available === true).length;

      return {
        key: String(group.type.id),
        label: group.type.name,
        roomTypeGroup: null,
        rooms,
        total_rooms: rooms.length,
        booked_rooms: 0,
        blocked_rooms: 0,
        max_available_rooms: available,
        isDisabled: available === 0,
      };
    });
}

export function resolveWalkInRoomTypeGroup(filteredRoomsData, room) {
  if (!room || !filteredRoomsData?.length) return null;
  const typeId = room.room_type_id;
  if (typeId == null) return null;
  return filteredRoomsData.find((group) => String(group.room_type.id) === String(typeId)) || null;
}

export function resolveWalkInRoomTypeImage(filteredRoomsData, displayGroup, room) {
  const group = displayGroup?.roomTypeGroup || resolveWalkInRoomTypeGroup(filteredRoomsData, room);
  const meta = group?.room_type || {};
  return meta.image_url || meta.image || '';
}

export function resolveWalkInGroupImage(displayGroup) {
  const meta = displayGroup?.roomTypeGroup?.room_type || {};
  return meta.image_url || meta.image || '';
}
